import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlidersH, faSlideshare, faSliders, faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { faSlideshare as faSlideshareBrand } from '@fortawesome/free-brands-svg-icons';

function VisualBriefHome() {
  return (
    <div className="min-h-screen bg-black py-2">
      <header className="px-4 bg-black border-b border-teal-500 mb-2">
        <h1 className="text-xl sm:text-2xl font-bold text-teal-500 text-center">
          VisualBrief
        </h1>
         <p className="text-gray-300 text-xs lg:text-sm font-medium text-center">
          Presentation with versatality!
        </p>
      </header>

      <section className="flex flex-col items-center justify-center min-h-[20vh] px-4 mb-2 text-center">
        <div className="text-2xl lg:text-4xl mb-2 drop-shadow-lg">
          📊🗨️🔊
        </div>
        <p className="text-white text-sm lg:text-lg font-medium max-w-md">
          Create, share and engage with visual presentations.
        </p>
      </section>
      <section className="min-h-[50vh] px-4 py-2 mx-auto border-t border-teal-500">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 place-items-center">
          <CardLink to="/visualbrief-myvb" icon={faSlidersH} text="My Presentation Library" />
          <CardLink to="/visualbrief-publicvb" icon={faSlideshareBrand} text="Public Presentations" />
          <CardLink to="/visualbrief-vbforme" icon={faSliders} text="Presentations for Me" />
          <CardLink to="/visualbrief-about" icon={faCircleQuestion} text="About VisualBriefs" />
        </div>
      </section>

      <footer className="bg-black border-t border-teal-500 text-white py-2">
        <div className=" mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm text-yellow-200">
            © 2025 Think5Whys Global DeepTech Solutions.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-pink-400">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-pink-400">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-pink-400">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-pink-400">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

const CardLink = ({ to, icon, text }) => (
  <Link
    to={to}
    className="group relative bg-teal-600 backdrop-blur-sm border border-white/10 rounded-xl p-6 shadow-lg hover:shadow-2xl hover:shadow-teal-500/50 transition-all duration-500 hover:scale-105 hover:bg-gradient-to-r hover:from-teal-500/20 hover:to-emerald-500/20 overflow-hidden text-white flex items-center justify-center gap-4 text-center sm:text-left before:absolute before:inset-0 before:bg-gradient-to-r before:from-teal-400/0 before:to-teal-400/20 before:origin-left before:translate-x-[-100%] before:transition-transform before:duration-700 hover:before:translate-x-0"
  >
    <div className='flex flex-col'>
      <FontAwesomeIcon
        icon={icon}
        className="text-xl lg:text-2xl group-hover:scale-110 group-hover:rotate-12 group-hover:text-teal-300 transition-all duration-500 z-10"
      />
      <div className="text-sm lg:text-m font-semibold tracking-wide group-hover:text-teal-100 transition-colors duration-500 z-10">
        {text}
      </div>
    </div>
  </Link>
);

export default VisualBriefHome;